import {
  CurrencyCode,
  enumBillStatus,
} from '@rematter/frontend-lib-api-client';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export type OpenBillForPayment = {
  id: string;
  documentNumber: string;
  amount: { amount: number; currencyCode: CurrencyCode };
  openAmount: { amount: number; currencyCode: CurrencyCode };
  account: { id: string; name: string } | null;
};

export type OpenBillsForPaymentParams = {
  accountId?: string;
  currencyCode?: CurrencyCode;
  facilityIDs?: string[];
};

export const openBillsForPaymentAtom = createQueryAtomFactory(
  'finance.openBillsForPayment',
  (params: OpenBillsForPaymentParams) => ({
    bills: {
      __args: {
        filter: {
          statuses: [enumBillStatus.Pending],
          accountIDs: params.accountId ? [params.accountId] : undefined,
          currencyCode: params.currencyCode,
          facilityIDs: params.facilityIDs,
          minOpenBalance: 0.01,
        },
        pagination: { offset: 0, limit: 100 },
      },
      entries: {
        id: true,
        documentNumber: true,
        amount: { amount: true, currencyCode: true },
        openAmount: { amount: true, currencyCode: true },
        account: { id: true, name: true },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): { bills: OpenBillForPayment[]; total: number } => {
      const entries = data?.bills.entries;
      if (!entries) {
        return { bills: [], total: 0 };
      }

      return {
        bills: entries.map((it) => ({
          id: it.id,
          documentNumber: it.documentNumber,
          amount: {
            amount: it.amount.amount,
            currencyCode: it.amount.currencyCode,
          },
          openAmount: {
            amount: it.openAmount.amount,
            currencyCode: it.openAmount.currencyCode,
          },
          account: it.account
            ? { id: it.account.id, name: it.account.name }
            : null,
        })),
        total: data?.bills.page.total ?? 0,
      };
    },
  },
);
